import { render, staticRenderFns } from "./WebmailCompose.vue?vue&type=template&id=bbcf2e9e&scoped=true&"
import script from "./WebmailCompose.vue?vue&type=script&lang=js&"
export * from "./WebmailCompose.vue?vue&type=script&lang=js&"
import style0 from "./WebmailCompose.vue?vue&type=style&index=0&id=bbcf2e9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf2e9e",
  null
  
)

component.options.__file = "WebmailCompose.vue"
export default component.exports